/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Col_Current_ActivityInputs */

const en_reports_col_current_activity = /** @type {(inputs: Reports_Col_Current_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current activity`)
};

const pt_br2_reports_col_current_activity = /** @type {(inputs: Reports_Col_Current_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividade Atual`)
};

/**
* | output |
* | --- |
* | "Current activity" |
*
* @param {Reports_Col_Current_ActivityInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_col_current_activity = /** @type {((inputs?: Reports_Col_Current_ActivityInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Col_Current_ActivityInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_col_current_activity(inputs)
	return pt_br2_reports_col_current_activity(inputs)
});